@if (appBusyState) {
<div class="app-busy">
    @if (appBusyState['templatePortal']) {
    <ng-container [cdkPortalOutlet]="appBusyState['templatePortal']" />
    }@else {
    <p class="center">
        {{appBusyState['message'] || ''}}
    </p>
    }
</div>
}